import Styles from '../../../1.manual/3.school/2.edit/styles.module.css';
import React, { useState } from 'react';
import DefaultInput1 from '../../../../package/1-input/index';
import { getFirestore } from 'firebase/firestore';
import { writeJobPostingBothStores } from '../../jobPostingRef';
import DefaultCheckBox from '../../../../package/checkBox/index';
import DefaultSelect1 from '../../../../package/1-select/index';
import DefaultTextarea1 from '../../../../package/1-textarea/index';
import ErrorMessage from '../../../../package/error/index';
import { applicationInfoData, infoData, ValidationError } from 'src/type';
import DefaultInputTime3 from 'src/salon/package/3-input-time';
import DefaultDesc from 'src/salon/package/desc';

type RecruitNumber = {
  companyId: string;
  year: string;
  setChangeData:  React.Dispatch<React.SetStateAction<boolean>>;
  info: infoData;
  applicationInfo: applicationInfoData;
  setApplicationInfo: React.Dispatch<React.SetStateAction<applicationInfoData>>;
};

const SchoolApplicationInfo: React.FC<RecruitNumber> = ({ companyId, year, setChangeData, info, applicationInfo, setApplicationInfo }) => {

  const [ errorMessage, setErrorMessage ] = useState<ValidationError>(null);
  const [ banner, setBanner ] = useState<boolean>(false);

  function validateData(data: applicationInfoData): ValidationError {
    if (info.business.contents.includes("理容") && !data.recruitsBarber) return { message: '採用人数 理容を数値で入力してください。', fieldId: 'recruitsBarber' };
    if (info.business.contents.includes("理容") && data.recruitsBarber && !/^\d+$/.test(data.recruitsBarber)) return { message: '採用人数 理容を数値で入力してください。', fieldId: 'recruitsBarber' };
    if (info.business.contents.includes("美容") && !data.recruitsBeauty) return { message: '採用人数 美容を数値で入力してください。', fieldId: 'recruitsBeauty' };
    if (info.business.contents.includes("美容") && data.recruitsBeauty && !/^\d+$/.test(data.recruitsBeauty)) return { message: '採用人数 美容を数値で入力してください。', fieldId: 'recruitsBeauty' };
    if (info.business.contents.includes("メイク") && !data.recruitsMake) return { message: '採用人数 メイクを数値で入力してください。', fieldId: 'recruitsMake' };
    if (info.business.contents.includes("メイク") && data.recruitsMake && !/^\d+$/.test(data.recruitsMake)) return { message: '採用人数 メイクを数値で入力してください。', fieldId: 'recruitsMake' };
    if (info.business.contents.includes("アイ") && !data.recruitsEye) return { message: '採用人数 アイを数値で入力してください。', fieldId: 'recruitsEye' };
    if (info.business.contents.includes("アイ") && data.recruitsEye && !/^\d+$/.test(data.recruitsEye)) return { message: '採用人数 アイを数値で入力してください。', fieldId: 'recruitsEye' };
    if (info.business.contents.includes("ネイル") && !data.recruitsNeil) return { message: '採用人数 ネイルを数値で入力してください。', fieldId: 'recruitsNeil' };
    if (info.business.contents.includes("ネイル") && data.recruitsNeil && !/^\d+$/.test(data.recruitsNeil)) return { message: '採用人数 ネイルを数値で入力してください。', fieldId: 'recruitsNeil' };
    if (info.business.contents.includes("ブライダル") && !data.recruitsBridal) return { message: '採用人数 ブライダルを数値で入力してください。', fieldId: 'recruitsBridal' };
    if (info.business.contents.includes("ブライダル") && data.recruitsBridal && !/^\d+$/.test(data.recruitsBridal)) return { message: '採用人数 ブライダルを数値で入力してください。', fieldId: 'recruitsBridal' };
    if (info.business.contents.includes("エステ") && !data.recruitsAesthetic) return { message: '採用人数 エステを数値で入力してください。', fieldId: 'recruitsAesthetic' };
    if (info.business.contents.includes("エステ") && data.recruitsAesthetic && !/^\d+$/.test(data.recruitsAesthetic)) return { message: '採用人数 エステを数値で入力してください。', fieldId: 'recruitsAesthetic' };
    if (Number(data.recruitsAesthetic) + Number(data.recruitsBarber) + Number(data.recruitsBeauty) + Number(data.recruitsMake) + Number(data.recruitsEye) + Number(data.recruitsNeil) + Number(data.recruitsBridal) === 0) return { message: '1つ以上の職種で1人以上の募集人数を設定してください', fieldId: 'recruitsBarber' };

    if (data.applicationDocuments.length === 0) return { message: '応募書類を選択してください。', fieldId: 'applicationDocuments' };
    if (!data.submissionMethod) return { message: '応募方法を選択してください。', fieldId: 'submissionMethod' };
    if (!data.storeTour) return { message: 'サロン見学の有無を入力してください。', fieldId: 'storeTour' };
    if (data.selectionDate.length <= 7) return { message: '応募期限を入力してください。', fieldId: 'selectionDate' };
    if (!/^[0-9-]+$/.test(data.selectionDate)) return { message: '応募期限を半角数字で入力してください。', fieldId: 'selectionDate' };
    if (!data.selectionRound1) return { message: '1次選考を選択してください。', fieldId: 'selectionRound1' };
    if (!data.selectionRound2) return { message: '2次選考を選択してください。', fieldId: 'selectionRound2' };
    if (!data.selectionRound3) return { message: '3次選考を選択してください。', fieldId: 'selectionRound3' };
    return null;
  }

  function check() {
    setErrorMessage(null);

    window.scrollTo(0, 0);
    const error = validateData(applicationInfo);
    if (error) {
      setErrorMessage(error);

      const el = document.getElementById(error.fieldId);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        el.focus?.();
      }

      return;
    }
    save(true);
  }

  const [ uploading, setUploading ] = useState(false);

  const save = async (isCompleted: boolean) => {
    try {
      setUploading(true);
      const db = getFirestore();

      const payload = {
        ...applicationInfo,
        isCompleted,
        time: new Date(),
      };

      await writeJobPostingBothStores(db, companyId, year, {
        applicationInfo: payload,
      });

      setChangeData(false);

    } catch (error) {
      console.error("保存エラー:", error);
      setUploading(false);
    } finally {
      setUploading(false);
      setBanner(true);
      setTimeout(() => { setBanner(false); }, 1500);
    }
  };

  const isNumeric = (str: string) => !!str && !/^[0-9]+$/.test(str);
  const isValidPhoneNumber = (str: string) => !!str && !/^[0-9-]+$/.test(str);

  return (
    <>
    {errorMessage && <ErrorMessage message={errorMessage.message} />}
    {banner && <div className={Styles.banner}>保存しました。</div>}

    {uploading && (
      <div className={Styles.lockOverlay}>
        <div className={Styles.spinner} />
        <p>アップロード中...</p>
      </div>
    )}

    <div className={Styles.title_edit}>
      <h4>応募方法</h4>
      <div className={Styles.title_edit_btn}>
        <button className={Styles.save_box_now} onClick={() => save(false)}>一時保存</button>
        <button className={Styles.save_box_save} onClick={() => check()}>保存</button>
      </div>
    </div>

    <div className={Styles.test_box}>

      <div id="recruitsBarber" tabIndex={-1}></div>
      {info.business.contents.includes("理容") && (
      <>
        <DefaultInput1
          error={errorMessage?.fieldId === "recruitsBarber"}
          title={'募集人数 理容師'} length={3} place={''}
          value={applicationInfo.recruitsBarber}
          setValue={(val: string) => {
            setApplicationInfo((prev) => ({ ...prev, recruitsBarber: val }));
            setChangeData(true);
            setErrorMessage(null);
          }}/>
        <DefaultDesc text={"※募集人数がいない場合は0と記載ください。"} />
        <DefaultDesc text={"※半角数字で入力してください。"} type="error" error={isNumeric(applicationInfo.recruitsBarber)}  />
      </> )}

      {info.business.contents.includes("美容") && (
      <>
        <DefaultInput1
          error={errorMessage?.fieldId === "recruitsBeauty"}
          title={'募集人数 美容師'} length={3} place={''}
          value={applicationInfo.recruitsBeauty}
          setValue={(val: string) => {
            setApplicationInfo((prev) => ({ ...prev, recruitsBeauty: val }));
            setChangeData(true);
            setErrorMessage(null);
          }}/>
        <DefaultDesc text={"※募集人数がいない場合は0と記載ください。"} />
        <DefaultDesc text={"※半角数字で入力してください。"} type="error" error={isNumeric(applicationInfo.recruitsBeauty)}  />
      </> )}

      <div id="recruitsMake" tabIndex={-1}></div>
      {info.business.contents.includes("メイク") && (
      <>
        <DefaultInput1
          error={errorMessage?.fieldId === "recruitsMake"}
          title={'募集人数 メイク'} length={3} place={''}
          value={applicationInfo.recruitsMake}
          setValue={(val: string) => {
            setApplicationInfo((prev) => ({ ...prev, recruitsMake: val }));
            setChangeData(true);
            setErrorMessage(null);
          }} />
        <DefaultDesc text={"※募集人数がいない場合は0と記載ください。"} />
        <DefaultDesc text={"※半角数字で入力してください。"} type="error" error={isNumeric(applicationInfo.recruitsMake)}  />
      </>
      )}

      <div id="recruitsEye" tabIndex={-1}></div>
      {info.business.contents.includes("アイ") && (
      <>
        <DefaultInput1
          error={errorMessage?.fieldId === "recruitsEye"}
          title={'募集人数 アイ'} length={3} place={''}
          value={applicationInfo.recruitsEye}
          setValue={(val: string) => {
            setApplicationInfo((prev) => ({ ...prev, recruitsEye: val }));
            setChangeData(true);
            setErrorMessage(null);
          }} />
        <DefaultDesc text={"※募集人数がいない場合は0と記載ください。"} />
        <DefaultDesc text={"※半角数字で入力してください。"} type="error" error={isNumeric(applicationInfo.recruitsEye)}  />
      </>
      )}

      <div id="recruitsNeil" tabIndex={-1}></div>
      {info.business.contents.includes("ネイル") && (
      <>
        <DefaultInput1
          error={errorMessage?.fieldId === "recruitsNeil"}
          title={'募集人数 ネイル'} length={3} place={''}
          value={applicationInfo.recruitsNeil}
          setValue={(val: string) => {
            setApplicationInfo((prev) => ({ ...prev, recruitsNeil: val }));
            setChangeData(true);
            setErrorMessage(null);
          }} />

        <DefaultDesc text={"※募集人数がいない場合は0と記載ください。"} />
        <DefaultDesc text={"※半角数字で入力してください。"} type="error" error={isNumeric(applicationInfo.recruitsNeil)}  />
      </>
      )}

      <div id="recruitsBridal" tabIndex={-1}></div>
      {info.business.contents.includes("ブライダル") && (
      <>
        <DefaultInput1
          error={errorMessage?.fieldId === "recruitsBridal"}
          title={'募集人数 ブライダル'} length={3} place={''}
          value={applicationInfo.recruitsBridal} setValue={(val: string) => {
            setApplicationInfo((prev) => ({ ...prev, recruitsBridal: val }));
            setChangeData(true);
            setErrorMessage(null);
          }} />
        <DefaultDesc text={"※募集人数がいない場合は0と記載ください。"} />
        <DefaultDesc text={"※半角数字で入力してください。"} type="error" error={isNumeric(applicationInfo.recruitsBridal)}  />
      </>
      )}

      <div id="recruitsAesthetic" tabIndex={-1}></div>
      {info.business.contents.includes("エステ") && (
      <>
        <DefaultInput1
          error={errorMessage?.fieldId === "recruitsAesthetic"}
          title={'募集人数 エステ'} length={3} place={''}
          value={applicationInfo.recruitsAesthetic} setValue={(val: string) => {
            setApplicationInfo((prev) => ({ ...prev, recruitsAesthetic: val }));
            setChangeData(true);
            setErrorMessage(null);
          }} />

        <DefaultDesc text={"※募集人数がいない場合は0と記載ください。"} />
        <DefaultDesc text={"※半角数字で入力してください。"} type="error" error={isNumeric(applicationInfo.recruitsAesthetic)} />
      </>
      )}

    </div>

    <div className={Styles.test_box}>

      <div id="storeTour" tabIndex={-1}></div>
      <DefaultSelect1
        error={errorMessage?.fieldId === "storeTour"}
        title={'サロン見学'} list={[ '未選択', '見学あり', '見学なし' ]}
        value={applicationInfo.storeTour}
        setValue={(val: string) => {
          setApplicationInfo((prev) => ({ ...prev, storeTour: val }));
          setChangeData(true);
          setErrorMessage(null);
        }} />

    </div>

    <div className={Styles.test_box}>

      <div id="applicationDocuments" tabIndex={-1}></div>
      <DefaultCheckBox
        error={errorMessage?.fieldId === "applicationDocuments"}
        title={'応募書類'} list={[ "履歴書", "成績証明書",  "健康診断書","卒業見込証明書","出席証明書", ]}
        value={applicationInfo.applicationDocuments}
        setValue={(val: string[]) => {
          setApplicationInfo((prev) => ({ ...prev, applicationDocuments: val }));
          setChangeData(true);
          setErrorMessage(null);
        }} />

      <div id="submissionMethod" tabIndex={-1}></div>
      <DefaultSelect1
        error={errorMessage?.fieldId === "submissionMethod"}
        title={'応募方法'} list={[ '未選択', "郵送", "書類持参", "WEB応募" ]}
        value={applicationInfo.submissionMethod}
        setValue={(val: string) => {
          setApplicationInfo((prev) => ({ ...prev, submissionMethod: val }));
          setChangeData(true);
          setErrorMessage(null);
        }} />


      <div id="selectionDate" tabIndex={-1}></div>
      <DefaultInputTime3
        error={errorMessage?.fieldId === "selectionDate"}
        title={'応募期限'} value={applicationInfo.selectionDate}
        setValue={(val: string) => {
          setApplicationInfo((prev) => ({ ...prev, selectionDate: val }));
          setChangeData(true);
          setErrorMessage(null);
        }} />
      <DefaultDesc text={"※半角数字で入力してください。"} type="error" error={isValidPhoneNumber(applicationInfo.selectionDate)} />

    </div>

    <div className={Styles.test_box}>

      <div id="selectionRound1" tabIndex={-1}></div>
      <DefaultSelect1
        error={errorMessage?.fieldId === "selectionRound1"}
        title={'1次選考'}
        value={applicationInfo.selectionRound1}
        setValue={(val: string) => {
          setApplicationInfo((prev) => ({ ...prev, selectionRound1: val }));
          setChangeData(true);
          setErrorMessage(null);
        }}
        list={[ '未選択', "書類審査", "面接", "グループ面接", "技術チェック", "サロンワーク", "グループディスカッション", "特になし", ]}  />

      <div id="selectionRound2" tabIndex={-1}></div>
      <DefaultSelect1
        error={errorMessage?.fieldId === "selectionRound2"}
        title={'2次選考'}
        value={applicationInfo.selectionRound2} setValue={(val: string) => {
          setApplicationInfo((prev) => ({ ...prev, selectionRound2: val }));
          setChangeData(true);
          setErrorMessage(null);
        }}
        list={[ '未選択', "書類審査", "面接", "グループ面接", "技術チェック", "サロンワーク", "グループディスカッション", "特になし", ]}  />

      <div id="selectionRound3" tabIndex={-1}></div>
      <DefaultSelect1
        error={errorMessage?.fieldId === "selectionRound3"}
        title={'3次選考'}
        value={applicationInfo.selectionRound3} setValue={(val: string) => {
          setApplicationInfo((prev) => ({ ...prev, selectionRound3: val }));
          setChangeData(true);
          setErrorMessage(null);
        }}
        list={[ '未選択', "書類審査", "面接", "グループ面接", "技術チェック", "サロンワーク", "グループディスカッション", "特になし", ]}  />

        <div id="selectionOtherDetails" tabIndex={-1}></div>
        <DefaultTextarea1
          error={errorMessage?.fieldId === "selectionOtherDetails"}
          title={'その他'} length={60} place={'応募受付は2月1日から開始予定です。内定通知後、承諾までの期間は1週間以内を目安としています。'}
          value={applicationInfo.selectionOtherDetails} setValue={(val: string) => {
            setApplicationInfo((prev) => ({ ...prev, selectionOtherDetails: val }));
            setChangeData(true);
            setErrorMessage(null);
          }} />
        <DefaultDesc text={"※履歴書の送付場所など、ご入力ください。"} />

    </div>
    </>
  );
}

export default SchoolApplicationInfo;
